import styled from "styled-components";
import {GLOBAL_STYLE_CONFIG} from "../../../app/styles/GlobalStyles";

export const StyledControlWrapper = styled.div`
    border: 1px solid;
    border-radius: var(${GLOBAL_STYLE_CONFIG.variable('dropdown', 'border-radius')}, ${({theme}) => theme.dropdown.borderRadius});
    border-color: var(${GLOBAL_STYLE_CONFIG.variable('dropdown', 'border-color')}, ${({theme}) => theme.dropdown.borderColor});

    padding: var(${GLOBAL_STYLE_CONFIG.variable('dropdown', 'header-padding')},  9px 35px 9px clamp(10px, 2vw, 20px));
    display: flex;
    align-items: center;
    position: relative;
    width: max-content;
    max-width: 100%;
    font-family: var(${GLOBAL_STYLE_CONFIG.variable('dropdown', 'font-family')}, inherit);
    font-size: var(${GLOBAL_STYLE_CONFIG.variable('dropdown', 'font-size')}, clamp(14px, 2vw, 16px));
    font-weight: var(${GLOBAL_STYLE_CONFIG.variable('dropdown', 'font-weight')}, 500);
    line-height: 120%;
`

export const StyleDropdownHeader = styled.div`
    width: 100%;
    border-width: 1px;
    border-style: solid;
    border-radius: var(${GLOBAL_STYLE_CONFIG.variable('dropdown', 'border-radius')}, ${({theme}) => theme.dropdown.borderRadius});
    border-color: var(${GLOBAL_STYLE_CONFIG.variable('dropdown', 'border-color')}, ${({theme}) => theme.dropdown.borderColor});
    padding: var(${GLOBAL_STYLE_CONFIG.variable('dropdown', 'header-padding')}, 9px 35px 9px clamp(10px, 2vw, 20px));

    display: flex;
    align-items: center;
    position: relative;
    min-width: 180px;
    max-width: 100%;
    background-color: transparent;
    cursor: pointer;
    position: relative;
    font-family: var(${GLOBAL_STYLE_CONFIG.variable('dropdown', 'font-family')}, inherit);
    font-size: var(${GLOBAL_STYLE_CONFIG.variable('dropdown', 'font-size')}, clamp(14px, 2vw, 16px));
    font-weight: var(${GLOBAL_STYLE_CONFIG.variable('dropdown', 'font-weight')}, 500);
    line-height: 120%;
    color: var(${GLOBAL_STYLE_CONFIG.variable('dropdown', 'text-color')}, ${({theme}) => theme.dropdown.textColor});

    .${GLOBAL_STYLE_CONFIG.splitByPrefix('icon-arrow')} {
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        width: 10px;
        height: 10px;
    }

    &.${GLOBAL_STYLE_CONFIG.splitByPrefix('open')} {
        border-top-left-radius:  var(${GLOBAL_STYLE_CONFIG.variable('dropdown', 'border-radius')}, ${({theme}) => theme.dropdown.borderRadius});
        border-top-right-radius:  var(${GLOBAL_STYLE_CONFIG.variable('dropdown', 'border-radius')}, ${({theme}) => theme.dropdown.borderRadius});
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    
        background-color: var(${GLOBAL_STYLE_CONFIG.variable('dropdown', 'bg-color-open')}, white);

        .${GLOBAL_STYLE_CONFIG.splitByPrefix('icon-arrow')} {
            top: 15px;
            transform: rotate(-180deg);
        }
    }

`

export const StyleDropdownBody = styled.div`
    position: absolute;
    top: 100%;
    z-index: 3;
    border-width: 1px;
    border-style: solid;
    border-radius: 0 0 var(${GLOBAL_STYLE_CONFIG.variable('dropdown', 'border-radius')}, ${({theme}) => theme.dropdown.borderRadius}) var(${GLOBAL_STYLE_CONFIG.variable('dropdown', 'border-radius')}, ${({theme}) => theme.dropdown.borderRadius});
    border-color: var(${GLOBAL_STYLE_CONFIG.variable('dropdown', 'border-color')}, ${({theme}) => theme.dropdown.borderColor});
    border-top: none;

    background-color: var(${GLOBAL_STYLE_CONFIG.variable('dropdown', 'bg-color-open')}, white);
    padding: var(${GLOBAL_STYLE_CONFIG.variable('dropdown', 'header-padding')}, 10px 20px);
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-height: 250px;
    overflow-y: auto;
    overflow-x: hidden;
    font-family: var(${GLOBAL_STYLE_CONFIG.variable('dropdown', 'font-family')}, inherit);
    
`

export const StyledDropdownControl = styled.div<{ width?: string }>`
    display: flex;
    flex-direction: column;
    position: relative;
    width: ${props => props.width ? props.width : "max-content"};
    max-width: 100%;
`



